<template>
    <div class="inline-msg-container">
        <div v-html="content"></div>
        
    </div>
</template>

<script>

    import api from '../../api/api'

    export default {

        props: ['message'],

        data() {
            return {
                content: null
            }
        },

        mounted() {
            api.get('/messages/'  + this.message.messageID + '/content')
            .then((response) => {
                this.content = response.data;
            });
        }

    }

</script>